<template>
    <f7-page name="beneficiary-created" @page:afterin="afterin">
        <f7-navbar class="view-mobile no-border">
            <f7-nav-left class="back-button">
                <f7-link icon-f7="chevron_left" @click="goHome" color="black"></f7-link>
            </f7-nav-left>
            <f7-nav-right></f7-nav-right>
        </f7-navbar>

        <f7-block>
            <div class="fs-24 b mt-20 mb-20">
                {{ isCreateBeneficiary === true ? $t('beneficiary-created-title') : $t('beneficiary-modified-title') }}
            </div>
            <div class="b fs-18 mb-sm">{{ $t('beneficiary-recipient-details') }}</div>
            
            <BeneficiaryDetails v-if="isRenderBeneficiaryDetails == true && homeCountryList.length > 0" :beneDetails="beneficiaryDetails" :key="beneficiaryDetailsKey" />

            <f7-button round large fill @click="goToNextPage('sendmoney')" class="mt-5 view-desktop" :disabled="false">{{$t('sendmoney-title')}}</f7-button>

            <f7-button round large fill @click="goToNextPage('skip')" class="mt-md view-desktop color-gray3 text-color-green" :disabled="false">{{$t('general-text-skip')}}</f7-button>
        </f7-block>

        <f7-toolbar position="bottom" no-hairline class="toolbar-with-stacked-button  view-mobile">        
            <f7-button large fill @click="goToNextPage('sendmoney')" :disabled="false">
                {{$t('sendmoney-title')}}
            </f7-button>
            <f7-button class="color-gray3 text-color-green" large fill @click="goToNextPage('skip')" :disabled="false">
              {{$t('general-text-skip')}}
            </f7-button>
        </f7-toolbar>
    </f7-page>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    import BeneficiaryDetails from '../../components/beneficiary-details.vue';

    export default {
        data() {
            return {
                beneficiaryId               : 0,
                beneficiaryDetails          : [],
                beneficiaryDetailsKey       : 0,
                isRenderBeneficiaryDetails  : false,
            }
        },
        computed: {
            ...mapGetters('beneficiary', [
                'showFormSet',
                'showFormInput',
                'email',
                'emailLabel',
                'isCreateBeneficiary',
                'newBeneficiaryId',
                'homeCountryList',
                'provinceList',
                'cityList',
                'homeCountryId',
                'routerTo',
            ])
        },
        components: {
            BeneficiaryDetails
        },
        mounted() {
            // Required for everypage. Toggle desktop-view footer.
            this.toggleFooterVisibility(false)
            this.$f7.$('.page-content').on('scroll', (e) => {
                this.toggleFooterVisibility(e.target)
            })

            if(this.newBeneficiaryId > 0){
                this.loadBeneficiaryDetails(this.newBeneficiaryId)
            }else{
                this.$f7router.navigate("/beneficiary-list");
            }

            //this.getHomeCountryList();
            //console.log("HOME COUNTRY LIST : ", this.homeCountryList)

            //console.log("CREATED routerTo : "+this.routerTo)
        },
        methods: {
            ...mapActions('beneficiary', [
                'setNewBeneficiaryId',
                'setHomeCountryList',
                'setProvinceList',
                'setCityList'
            ]),
            
            afterin(){
                window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
            },

            async loadBeneficiaryDetails(beneId){
                this.showPreloader()
                
                const beneficiaryDetailsPromise = await this.$api.beneficiary.getBeneficiaryDetail(beneId);
                //console.log("BENE DETAILS : ", beneficiaryDetails);
                this.beneficiaryDetails.push(beneficiaryDetailsPromise)

                this.beneficiaryDetails.push(beneficiaryDetailsPromise)
                this.isRenderBeneficiaryDetails = true;
                this.beneficiaryDetailsKey += 1;

                await this.getProvinceList();
                this.getCityList();

                this.hidePreloader()
                
            },

            async getHomeCountryList(){
                const countryPromise     = await this.$api.beneficiary.getCountryList();
                this.setHomeCountryList(countryPromise);
                //console.log("countryPromise : ", countryPromise)
            },

            async getProvinceList(){
                const provincePromise     = await this.$api.beneficiary.getProvinceList(this.beneficiaryDetails[0].homeCountryId);
                this.setProvinceList(provincePromise);
                //console.log("provincePromise : ", provincePromise)
            },

            async getCityList(){
                const homeCountryID = this.beneficiaryDetails[0].homeCountryId;
                const provinceID    = this.beneficiaryDetails[0].address.provinceId;
                if(provinceID > 0){
                    const cityPromise    = await this.$api.beneficiary.getCityList(homeCountryID, provinceID);
                    this.setCityList(cityPromise);
                    //console.log("cityPromise : ", cityPromise)
                }
                
            },

            goToNextPage(choice){
                //console.log("CHOICE : "+choice)
                //console.log("this.$f7route : ", this.$f7route.params.id)
                //console.log("beneficiaryDetails : ", this.beneficiaryDetails)
                
                if(choice == "sendmoney"){
                    var transactionData                  = this.$store.state.transaction
                    transactionData.beneficiaryId        = this.newBeneficiaryId
                    transactionData.beneficiaryFirstName = this.beneficiaryDetails[0].firstName
                    transactionData.beneficiaryAlias     = this.beneficiaryDetails[0].beneficiaryAlias
                    transactionData.beneficiaryFullName  = this.beneficiaryDetails[0].fullName
                    transactionData.p2hCustomerId        = this.beneficiaryDetails[0].p2hCustomerId
                    transactionData.bankAccountNo        = this.beneficiaryDetails[0].bankAccountNo
                    transactionData.bankId               = this.beneficiaryDetails[0].bankId
                    transactionData.bankBranchId         = this.beneficiaryDetails[0].bankBranchId
                    transactionData.bankName             = this.beneficiaryDetails[0].bank
                    transactionData.email                = this.beneficiaryDetails[0].email
                    transactionData.homeCountryId        = this.beneficiaryDetails[0].homeCountryId
                    transactionData.homeCountryName      = this.beneficiaryDetails[0].address.country
                    transactionData.homeCurrency         = this.beneficiaryDetails[0].homeCurrency
                    transactionData.hostCountryId        = this.beneficiaryDetails[0].originatingCountryId
                    transactionData.hostCountryName      = this.beneficiaryDetails[0].originatingCountry
                    transactionData.hostCurrency         = this.beneficiaryDetails[0].hostCurrency
                    transactionData.collectionAgentId    = this.beneficiaryDetails[0].collectionAgentId
                    transactionData.collectionAgent      = this.beneficiaryDetails[0].collectionAgent
                    transactionData.transactionTypeId    = this.beneficiaryDetails[0].transactionTypeId
                    transactionData.transactionType      = this.beneficiaryDetails[0].transactionType
                    transactionData.billerCode           = this.beneficiaryDetails[0].billerCode
                    transactionData.billingOrg           = this.beneficiaryDetails[0].billingOrg
                    transactionData.latestState          = ""
                    transactionData.provinceId           = this.beneficiaryDetails[0].address.provinceId
                    transactionData.province             = this.beneficiaryDetails[0].address.province
                    transactionData.cityId               = this.beneficiaryDetails[0].address.cityId
                    transactionData.city                 = this.beneficiaryDetails[0].address.city
                    transactionData.couponCode           = "";
                    transactionData.isQuickSend          = false;
                    transactionData.isMakePayment        = false;
                    transactionData.bankTypeId           = this.beneficiaryDetails[0].bankTypeId
                    transactionData.serviceId            = this.beneficiaryDetails[0].serviceId
                    transactionData.paymentPurpose       = this.beneficiaryDetails[0].paymentPurpose
                    transactionData.paymentPurposeId     = this.beneficiaryDetails[0].paymentPurposeId
                    transactionData.commissionAmount     = 0
                    transactionData.discountAmount       = 0
                    transactionData.deliveryMethodId     = this.beneficiaryDetails[0].deliveryMethodId
                    transactionData.deliveryMethodName   = this.beneficiaryDetails[0].deliveryMethod
                    if(this.$store.state.beneficiary.routerTo != "fxcalculator") {
                        transactionData.hostAmount       = ""
                        transactionData.homeAmount       = ""
                        transactionData.hostAmountReal   = 0
                        transactionData.homeAmountReal   = 0
                        transactionData.paymentMethodId  = 0
                        transactionData.paymentMethod    = ""
                    } else {
                        this.$store.state.beneficiary.routerTo = "fxcalculator"
                    }

                    // IS PHILGOV ?
                    if(transactionData.bankId == 4520 || transactionData.bankId == 4521 || transactionData.bankId == 4522 ) {

                        var currentDate = new Date()
                        transactionData.endMonth       = currentDate.getMonth()
                        transactionData.endYear        = null
                        transactionData.flexiFund      = null
                        transactionData.loanNumber     = ''
                        transactionData.mp2            = ''
                        transactionData.prn            = ''
                        transactionData.startMonth     = currentDate.getMonth()
                        transactionData.startYear      = null
                        transactionData.monthlyAmount  = null
                        transactionData.homeAmountReal = null
                        transactionData.bankBranchId   = 0

                        this.$f7router.navigate("/sendmoney/choose-transaction-type")
                    } else {
                        this.$f7router.navigate("/sendmoney/enter-amount")
                    }
                }else{ // SKIP button
                    if( this.routerTo == "sendMoney" || this.routerTo == "fxcalculator" || this.routerTo == "emptyListFxCalc" ){
                        this.$f7router.navigate("/sendmoney/select-beneficiary")
                    }else{
                        this.$f7router.navigate("/beneficiary-list");
                    }
                }
                
            },

            goHome() {
                this.$f7router.navigate("/home");
            },
        }
    }
</script>
